module.exports = __webpack_public_path__ + "img/ctrl-stub-0.53dedf5a.svg";